



import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

@Component
export default class extends Mixins() {
  @Prop() city!: string[];

  @Prop() addr!: string;

  @Prop() lnglat!: string;

  @Prop() callback!: (...args: any[]) => any;

  @Prop({ default: '300' }) height!: string

  @Prop({ default: 11 }) zoom!: number

  map: any = null;

  @Watch('addr')
  watchAddr(newVal: any, oldVal: any) {
    if (newVal !== oldVal && this.lnglat == "") {
      this.getLocation();
    }
  }

  @Watch('lnglat')
  watchLnglat(newVal: any, oldVal: any) {
    if (newVal !== oldVal) {
      const arr: any[] = newVal.split(',');
      this.map.add(
        new window.AMap.Marker({
          position: [arr[0], arr[1]],
        }),
      );
      this.map.setFitView();
    }
  }

  async getLocation() {
    let addr1 = '';

    const res = await this.$store.dispatch('api/areastr', {
      province_id: this.city[0],
      city_id: this.city[1],
      county_id: this.city[2],
    });

    if (res && res.Data) {
      addr1 = res.Data;
    }

    // if (this.lnglat) {
    //   return;
    // }
    // 加载点
    const geocoder = new window.AMap.Geocoder();

    geocoder.getLocation(addr1 + this.addr, (status: string, result: any) => {
      this.map.clearMap();
      if (status === 'complete' && result.geocodes.length) {
        const marker = new window.AMap.Marker({
          position: result.geocodes[0].location,
        });

        this.map.add(marker);

        // this.map.setFitView(marker);

        this.callback(
          result.geocodes[0].location.lng,
          result.geocodes[0].location.lat,
        );
      } else {
        // 根据地址查询位置失败
      }
    });
  }

  mounted() {
    this.map = new window.AMap.Map(this.$refs.container, {
      zoom: this.zoom,
    });

    if (this.city && this.addr) {
      this.getLocation();
    }

    this.map.on('click', (e: any) => {
      //   console.log(e);
      this.map.clearMap();

      this.map.add(
        new window.AMap.Marker({
          position: new window.AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat()),
        }),
      );
      this.map.setFitView();
      if (this.callback) {
        this.callback(e.lnglat.getLng(), e.lnglat.getLat());
      }
    });
  }

  addMarker(params: any) {
    this.map.add(
      new window.AMap.Marker({
        title: params.title,
        label: params.label,
        position: new window.AMap.LngLat(params.lng, params.lat),
      }),
    );
    this.map.setFitView();
  }
}
